function cov_ykd7tmpyh() {
  var path = "/app/src/webviews/pages/installments/index.ts";
  var hash = "d9dc6371fb7eb44a4ac1c296a986b4ca4adb744c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/webviews/pages/installments/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d9dc6371fb7eb44a4ac1c296a986b4ca4adb744c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ykd7tmpyh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_ykd7tmpyh();
export { InstallmentsWebview } from './installments';